module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1321/floorguide/onesence-8-f3b7b1f8cec217a9719a22436de7dfcd.webp";